import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * IAP Client IDフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const IapClientIdFormBase: FC<Props> = ({ register }) => (
  <Input
    id="iapClientId"
    type="text"
    {...register('iapClientId', {
      required: '必須項目です。',
      maxLength: {
        value: 100,
        message: 'IAP Client IDは 100 文字以内にする必要があります。',
      },
    })}
  />
);
